import { PayPalSettingsDto } from '@merchx-v2/shared-types/dist/dto/paypalSettings/paypal-settings.dto'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import * as t from '../actionTypes'

export type FetchPayPalSettingsForOptionsAction = FSA<undefined, PayPalSettingsDto[], string>
type FetchPayPalSettingsForOptions = (searchText?: string) => MrxThunk<FetchPayPalSettingsForOptionsAction>
type QueryResponse = GraphQLResponse<'payPalSettingsForOptions', PayPalSettingsDto[]>

const FETCH_PAYPAL_SETTINGS_FOR_OPTIONS = `
  query fetchPayPalSettingsForOptions ($filters: PayPalSettingsFilters!) {
    payPalSettingsForOptions (filters: $filters) {
      id
      name
    }
  }
`

const fetchPayPalSettingsForOptions: FetchPayPalSettingsForOptions = (searchText) => async (dispatch) => {
  dispatch({
    type: t.FETCH_PAYPAL_SETTINGS_FOR_OPTIONS,
    meta: { done: false }
  })

  try {
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_PAYPAL_SETTINGS_FOR_OPTIONS,
      variables: { filters: { searchText } }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { payPalSettingsForOptions } = data
    if (!payPalSettingsForOptions) {
      throw new Error("Can't get PayPal settings!")
    }

    dispatch({
      type: t.FETCH_PAYPAL_SETTINGS_FOR_OPTIONS,
      payload: payPalSettingsForOptions,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_PAYPAL_SETTINGS_FOR_OPTIONS,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchPayPalSettingsForOptions }
